import React, { useState, useEffect } from 'react';
export default function HomePage({ setPage }) {
    const [companyName, setCompanyName] = useState('Your Company');
    
      useEffect(() => {
        fetch('/config.json')
          .then((res) => res.json())
          .then((data) => {
            if (data.CompanyName) {
              setCompanyName(data.CompanyName);
            }
          })
          .catch((err) => {
            console.error('Failed to load config.json:', err);
          });
      }, []);
    
  return (
    <div
      className="min-h-screen bg-cover bg-center relative flex items-center justify-center"
      style={{
        backgroundImage: "url('/nursery-bg.jpg')"
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" />

      {/* Content */}
      <div className="relative z-10 text-center text-white px-6">
        <h1 className="text-5xl sm:text-6xl font-extrabold mb-4 drop-shadow-md">
          Welcome to {companyName}
        </h1>
        <p className="text-lg sm:text-xl mb-10 drop-shadow">
          Discover a world of flowers, plants, and natural beauty 🌿🌸
        </p>

        <div className="flex flex-col sm:flex-row gap-6 justify-center">
          <button
            onClick={() => setPage('login')}
            className="bg-teal-500 hover:bg-teal-600 text-white text-lg font-bold py-3 px-8 rounded-full shadow-lg transition transform hover:scale-105"
          >
            Login
          </button>
          <button
            onClick={() => setPage('register')}
            className="bg-white hover:bg-gray-100 text-teal-700 text-lg font-bold py-3 px-8 rounded-full shadow-lg transition transform hover:scale-105"
          >
            Register
          </button>
        </div>
      </div>
    </div>
  );
}
